import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dot, Loader2Icon } from "lucide-react";
import { toast } from "sonner";

import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import apiClient from "@/utils/apiClient";
import { getContactPipeline } from "@/utils/contactPipeline";

export default function ContactPipelineStage({ contact, pipelines, pipelineId, onUpdated }) {
  const [loading, setLoading] = useState(false);
  const pipeline = getContactPipeline(pipelines, contact.pipeline_status, pipelineId);
  const stages = pipeline?.stages ?? [];
  const currentStage = contact.pipeline_status?.stage;
  const currentId = String(currentStage?.id ?? "");
  const matchingStage = stages.find((stage) => String(stage.id) === currentId);

  if (stages.length === 0 || (currentId && !matchingStage)) {
    return (
      <Badge style={{ backgroundColor: currentStage?.color }}>
        {currentStage?.name || "Sin etapa"}
      </Badge>
    );
  }

  const changeStage = async (stageId) => {
    if (loading || stageId === currentId || !stages.some((stage) => String(stage.id) === stageId))
      return;

    setLoading(true);
    try {
      await apiClient.patch(`contacts/${contact.id}/pipeline-stage/`, { stage: stageId });
      await onUpdated();
    } catch (error) {
      toast.error(error.userMessage || "No se pudo actualizar la etapa del contacto.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <span className="block w-full" onClick={(event) => event.stopPropagation()}>
      <Select value={currentId} onValueChange={changeStage} disabled={loading}>
        <SelectTrigger className="w-full" aria-label={`Etapa de ${contact.name}`}>
          {loading ? (
            <span className="flex items-center gap-2">
              <Loader2Icon className="animate-spin h-4 w-4" />
              <span>Actualizando...</span>
            </span>
          ) : (
            <SelectValue placeholder="Seleccionar Estatus" />
          )}
        </SelectTrigger>
        <SelectContent onCloseAutoFocus={(event) => event.preventDefault()}>
          {stages.map((stage) => (
            <SelectItem key={stage.id} value={String(stage.id)}>
              <span className="flex items-center">
                <Dot className="h-10 w-10" style={{ color: stage.color || "#ccc" }} />
                {stage.name}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </span>
  );
}

ContactPipelineStage.propTypes = {
  contact: PropTypes.object.isRequired,
  pipelines: PropTypes.array,
  pipelineId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onUpdated: PropTypes.func.isRequired,
};
